import React, { useContext, useEffect, useState } from "react";
import { captureApi, leadsApi, orderApi } from "../../../../../crud/checkout.crud";
import {
	razorpayKey,
	publicStripePublishableKey,
	newRazorPayKey,
	newRazorPayEventIds
} from "../../../../../config/config";
// import logo from "../../../../../../public/favicon/favicon-32x32.png";
import {
	addTeamDetailsToCapture,
	errorToaster,
	getCurrencyId,
	getPaymentType,
	paymentErrorHelper,
	removeTeamDetailsFromSessionStorage,
	successToaster
} from "../../../../../helpers/utils";
import Router from "next/router";
import WidgetContext from "../../../../../contexts/WidgetContext";
import Modal from "react-modal";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripeCheckoutForm from "../ReviewTickets/StripeCheckoutForm";
import TapPayment from "../ReviewTickets/TapPayment";
import moment from "moment";
import { getGroupDiscountDetails } from "../../../../../helpers/common";

const stripeModalStyle = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)",
		minWidth: "32px",
		maxWidth: "420px",
		padding: "0",
		borderRadius: "0",
		border: "none",
		width: "80%",
		minheight: "32px"
		// maxheight: "80vh",
	}
};

const PaymentButton = ({
	eventDetails,
	orderAmount,
	attendeesDetails,
	query,
	couponCode,
	isWidget,
	setApiLoading,
	btnDisabled,
	reviewDetails,
	component,
	donationAmount,
	discount,
	waitlistDetails,
	selectedTickets
}) => {
	let updatedRazorpayKey = razorpayKey;
	if (newRazorPayKey && newRazorPayEventIds.includes(eventDetails.event_id)) {
		updatedRazorpayKey = newRazorPayKey;
	}
	const [leadsApiLoading, setLeadsApiLoading] = useState(false);
	const {
		leadsResponse,
		setOpenErrModal,
		setModalErrType,
		paymentMethod,
		isInternationalEvent,
		isInternationalTicket,
		setOpenPaymentModal,
		teamRegType,
		groupDiscounts
	} = useContext(WidgetContext);

	const allPaymentMethods = ["emi", "net_banking", "card", "wallet", "upi", "pay_later"];
	const [clientSecret, setClientSecret] = React.useState(""); // for stripe only
	const [stripeModal, setStripeModal] = useState(false); // for stripe only
	const [stripeUserID, setStripeUserID] = useState(""); // for stripe only

	const [TAPPayment, setTAPPayment] = useState(false);
	const [tapPaymentUrl, setTapPaymentUrl] = useState("");

	const currency = selectedTickets.find(obj => obj.currency_name !== eventDetails.currency_name)
		? selectedTickets?.find(obj => obj.currency_name !== eventDetails.currency_name).currency_name
		: eventDetails.currency_name;

	const publishableKey = publicStripePublishableKey; //for stripe
	const stripePromise = stripeUserID
		? loadStripe(publishableKey, { stripeAccount: stripeUserID })
		: loadStripe(publishableKey);

	const dateFormatOne = (start_date, end_date) => {
		const newStartDate = moment.utc(`${start_date}`).local().format("DD MMM, YYYY");
		const newEndDate = moment.utc(`${end_date}`).local().format("DD MMM, YYYY");
		return `${newStartDate} to ${newEndDate}`;
	};

	const makeOrderCall = async () => {
		setLeadsApiLoading(true);
		setOpenPaymentModal(true);
		const currencyId = getCurrencyId(currency);
		const orderId = leadsResponse.kh_order_id;
		const eventId = eventDetails.event_id;
		const groupDiscountCode = getGroupDiscountDetails(
			groupDiscounts,
			selectedTickets,
			couponCode
		).maxDiscountCode;

		const payload = {
			kh_order_id: orderId,
			order_amount: orderAmount,
			currency_id: parseInt(currencyId),
			...(!isInternationalTicket && {
				payment_method: isInternationalEvent
					? 2
					: parseInt(getPaymentType(paymentMethod, "pg_number"))
			}),
			// pg_type: isInternationalEvent ? 2 : 1,
			...(groupDiscountCode && couponCode ? { primary_discount_type: 2 } : {}),
			...(groupDiscountCode && { group_discount_code: groupDiscountCode }),
			...(couponCode && { coupon_code: couponCode }),
			...(waitlistDetails &&
				waitlistDetails[0].coupon_code && {
				coupon_code: waitlistDetails && waitlistDetails[0].coupon_code
			})
		};

		if (donationAmount) payload.donation_price = donationAmount;

		try {
			const res = await orderApi(eventId, payload);
			if (res.data.pg_type === 2) {
				//stripe
				setClientSecret(res.data.order_id);
				setStripeUserID(res.data.stripe_user_id);
				setStripeModal(true);
			} else if (res.data.pg_type === 1) {
				openPayModal(res.data.order_id, eventId, res.data.payment_method);
			} else if (res.data.pg_type === 5) {
				//window.open(res.data.order_url, "popup", "width=600,height=600");
				setTapPaymentUrl(res.data.order_url);
				setTAPPayment(true);
			}
		} catch (err) {
			console.log(err);
			const errMessage = err?.response?.data;
			if (errMessage.error.error_code) setModalErrType(errMessage.error.error_code);
			else setModalErrType(paymentErrorHelper(errMessage.error));
			setOpenErrModal(true);
		}
		setLeadsApiLoading(false);
	};

	const openPayModal = async (orderId, eventId, payment_method) => {
		const hide = allPaymentMethods.map(method => {
			if (
				(!isInternationalTicket,
					getPaymentType(payment_method, "pg_type_name") === "cards" && method == "card")
			) {
				// for card had to  write a condition because we use "cards" instead of "card" in function
				return { method: "" };
			} else if (
				getPaymentType(payment_method, "pg_type_name") !== method &&
				!isInternationalTicket
			) {
				return { method: method.split("_").join("") };
			} else return { method: "" };
		});

		const options = {
			key: updatedRazorpayKey,
			name: eventDetails.name,
			description: "",
			image: "/favicon/favicon-32x32.png",
			// method: { "card" : true, "netbanking" : true, "upi" : true, "wallet" : false, "paylater" : false },
			order_id: orderId, //This is a sample Order ID. Create an Order using Orders API. (https://razorpay.com/docs/payment-gateway/orders/integration/#step-1-create-an-order). Refer the Checkout form table given below
			handler: response => {
				const data = {
					order_id: orderId,
					payment_id: response.razorpay_payment_id,
					event_id: eventId,
					rzp_signature: response.razorpay_signature,
					...addTeamDetailsToCapture(teamRegType)
				};
				setApiLoading(true);
				captureApi(data)
					.then(res => {
						const data = JSON.stringify(res.data);
						const eventDet = JSON.stringify(eventDetails);
						sessionStorage.setItem("data", data);
						sessionStorage.setItem("eventDetails", eventDet);
						successToaster("Payment Successful");

						//remove utm parameters
						localStorage.removeItem("utm_campaign");
						localStorage.removeItem("utm_medium");
						localStorage.removeItem("utm_source");
						removeTeamDetailsFromSessionStorage(teamRegType);

						setOpenPaymentModal(false);
						//Redirect

						//Redirect
						if (isWidget)
							Router.push({
								pathname: `/widget/ticket-confirmation`,
								query: query
							});
						else if (eventId === "b76abab5-6eed-44ff-956a-f2f39ce6d748") {
							Router.push({
								pathname: `https://chat.whatsapp.com/IHoRiFsaMUe4OU1pgu5yJB`
							});
						} else if (eventDetails.redirection_url !== null) {
							if (eventDetails.redirection_url_timeout == 0) {
								window.location.replace(eventDetails.redirection_url);
							} else {
								query.redirection_url = eventDetails.redirection_url;
								query.redirection_url_timeout =
									eventDetails.redirection_url_timeout;
								Router.push({
									pathname: `/checkout/CustomRedirects`,
									query: query
								});
							}
						} else
							Router.push({
								pathname: `/checkout/ticket-confirmation`,
								query: `eventUrl=${eventDetails.event_url}`
							});
					})
					.catch(err => {
						const errMessage = err.response.data;
						if (errMessage.error.error_code)
							setModalErrType(errMessage.error.error_code);
						else setModalErrType("unexpected");
						setOpenErrModal(true);
						setApiLoading(false);
					});
			},
			modal: {
				ondismiss: function () {
					setOpenPaymentModal(false);
				}
			},
			// We can use this if its a logged in user and prefill these details.
			prefill: {
				name: reviewDetails[0].name,
				contact: reviewDetails[0].phone_number,
				email: reviewDetails[0].email_id
			},
			notes: {
				hosted_event_id: eventId
			},
			theme: { color: `${query.bg ? `#${query.bg}` : `#572148`}` },
			config: {
				display: {
					hide: [...hide],
					preferences: {
						show_default_blocks: true
					}
				}
			}
		};
		var rzp1 = new window.Razorpay(options);
		rzp1.open();
	};

	useEffect(() => {
		const script = document.createElement("script");
		script.src = "https://checkout.razorpay.com/v1/checkout.js";
		script.async = true;
		document.body.appendChild(script);
	}, []);

	const appearance = {
		theme: "stripe",

		// rules: {
		//     '.Input--invalid': {
		//       boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07), 0 0 0 2px var(--colorDanger)',
		//     },

		//     // See all supported class names and selector syntax below
		//   },
		variables: {
			colorPrimary: "#0570de",
			colorBackground: "#ffffff",
			colorText: "#0A0D13",
			colorDanger: "#df1b41",
			fontFamily: "Prompt, sans-serif",
			// spacingUnit: '2px',
			fontSizeBase: "16px",
			fontWeightMedium: "400",
			// fontLineHeight: '10',
			borderRadius: "4px",
			marginTop: "10px",
			spacingGridColumn: "20px",
			spacingGridRow: "20px",
			spacingAccordionItem: "20px"
			// See all possible variables below
		}
	};

	const stripeOptions = {
		clientSecret,
		appearance
	};

	return (
		<div className="align-self-center">
			<TapPayment
				eventDetails={eventDetails}
				orderAmount={orderAmount}
				currency={currency}
				isWidget={isWidget}
				callTapPayment={TAPPayment}
				setCallTapPayment={setTAPPayment}
				KHOrderId={leadsResponse?.kh_order_id}
				bookingIds={leadsResponse?.booking_ids?.join(",") || ""}
				tapPaymentUrl={tapPaymentUrl}
				query={query}
			/>
			{!leadsApiLoading && <div className="text-center mt-2">{component}</div>}
			<button
				className="btn cart-btn px-3 d-block btn-height mx-auto my-3 mt-md-0 proceed-btn-payment"
				disabled={leadsApiLoading || btnDisabled}
				onClick={() => {
					if (paymentMethod || isInternationalEvent) makeOrderCall();
					else errorToaster("Please select a payment method to proceed to payment");
				}}
				id={query?.paymentButtonId ? query?.paymentButtonId : ""}
			>
				{leadsApiLoading ? "Please Wait" : "Proceed to Payment"}
				{leadsApiLoading && <div className="spinner-border small-spinner ms-2"></div>}
			</button>
			{clientSecret && stripeModal && (
				<Modal
					isOpen={stripeModal}
					onRequestClose={() => {
						setStripeModal(false);
						setOpenPaymentModal(false);
					}}
					style=""
					shouldCloseOnOverlayClick={false}
					contentLabel="Subscribe Modal"
					style={stripeModalStyle}
				>
					<div
						className="stripe-modal-header d-flex justify-content-between"
						style={{
							background: `${query.btnBg ? `#${query.btnBg}` : `#572148`}`
						}}
					>
						{eventDetails.organiser_image_url && (
							<div className="stripe-modal-header-logo">
								<img
									src={eventDetails.organiser_image_url}
									alt=""
									className="organiser-logo"
								/>
							</div>
						)}
						<div className="mt-2">
							<p className="mb-0 event-name-date">{eventDetails.name}</p>
							<p className="mt-2 event-date">
								{dateFormatOne(eventDetails.start_date, eventDetails.end_date)}
							</p>
						</div>
						<i
							className="fas fa-times closeIcon close-icon"
							onClick={() => {
								setStripeModal(false);
								setOpenPaymentModal(false);
							}}
						></i>
					</div>
					<Elements options={stripeOptions} stripe={stripePromise}>
						<StripeCheckoutForm
							query={query}
							attendeesDetails={attendeesDetails}
							reviewDetails={reviewDetails}
							eventDetails={eventDetails}
							isWidget={isWidget}
							setApiLoading={setApiLoading}
							amount={orderAmount}
							setOpenPaymentModal={setOpenPaymentModal}
							teamRegType={teamRegType}
						/>
					</Elements>
				</Modal>
			)}
			<style jsx global>{`
				.small-spinner {
					width: 1rem;
					height: 1rem;
				}
				.register-btn {
					color: ${query.btnCl ? query.btnCl : "#ffffff"};
					background: ${query.btnBg ? query.btnBg : "#fb5850"};
				}

				.cart-btn {
					width: 90% !important;
					box-shadow: 2px 0px 8px rgba(0, 0, 0, 0.2) !important;
				}

				.register-btn:hover {
					color: ${query.btnCl ? query.btnCl : "#ffffff"};
				}
				.stripe-modal-header {
					// background: ${query.btnBg ? query.btnBg : "#572148"};
					padding: 15px 15px 10px;
					color: #ffffff;
					font-family: "Prompt";
					font-style: normal;
					font-weight: 500;
					font-size: 16px;
					line-height: 22px;
				}
				.stripe-modal-header-logo {
					width: 70px;
					height: 70px;
					background: #ffffff;
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 15%;
				}
				.organiser-logo {
					width: 50px;
					height: 50px;
					display: flex;
					justify-content: center;
					align-items: center;
				}
				.close-icon {
					font-size: 20px;
					color: rgba(255, 255, 255, 0.47);
					cursor: pointer;
				}
				.event-name-date {
					// width: 20em;
					// margin: 0.5em;
					width: 275px;
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
				.event-date {
					color: #ffffff;
					font-family: "Prompt";
					font-style: normal;
					font-weight: 400;
					font-size: 13px;
					line-height: 22px;
				}
				@media only screen and (max-width: 500px) {
					.event-name-date {
						width: 200px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
					}
					.event-date {
						font-family: "Prompt";
						font-style: normal;
						font-weight: 300;
						font-size: 11px;
						line-height: 22px;
					}
					@media only screen and (max-width: 390px) {
						.event-name-date {
							width: 130px;
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}
						.event-date {
							font-family: "Prompt";
							font-style: normal;
							font-weight: 300;
							font-size: 9px;
							line-height: 22px;
						}
					}
				}
			`}</style>
		</div>
	);
};

export default PaymentButton;
